import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'
import PartyCombobox from '../../../Combobox/PartyCombobox'
import { useThemeClassName_unstable } from '@fluentui/react-shared-contexts'
import { PartyType } from '../../Party/PartyForm'

export type PartyCardReportDto = {
    partyId: string
}

function ReportBody(): ReactElement {
    const themeClassName = useThemeClassName_unstable()
    const { values, setFieldValue } = useFormikContext<PartyCardReportDto>()
    return (
        <PartyCombobox
            listbox={{ className: themeClassName }}
            multiselect={false}
            selectedOptions={[values.partyId]}
            onOptionSelect={(_, data) => setFieldValue('partyId', data.selectedOptions?.[0])}
            filter={entity => entity.type === PartyType.Legal}
        />
    )
}

export default function PartyCardReportForm(): ReactElement {
    return (
        <ReportForm<PartyCardReportDto>
            title="Clientenkaart"
            generationType={DocumentGenerationType.PartyCard}
            initialValues={{ partyId: undefined }}
        >
            <ReportBody />
        </ReportForm>
    )
}
